"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMindsetCustomerConfiguration = parseMindsetCustomerConfiguration;
const reservedEndpointHostSuffixes = [".localhost", ".local", ".internal", ".home.arpa"];
function hasPublicEndpointHost(url) {
    const host = url.hostname.toLowerCase().replace(/\.$/u, "");
    return host.includes(".") && !/^[\d.]+$/.test(host) && !host.includes(":") &&
        host !== "localhost" && !reservedEndpointHostSuffixes.some(suffix => host.endsWith(suffix));
}
/** Validates public configuration, not its provenance or current tenant authorization. */
function parseMindsetCustomerConfiguration(input) {
    try {
        if (!input || typeof input !== "object" || Array.isArray(input))
            throw new Error();
        const value = input;
        const fields = ["schemaVersion", "environment", "tenantId", "applicationId", "gatewayUrl", "realtimeUrl"];
        if (Object.keys(value).length !== fields.length || fields.some(field => !Object.prototype.hasOwnProperty.call(value, field)) ||
            value.schemaVersion !== 1 || !["sandbox", "production"].includes(value.environment))
            throw new Error();
        const identifier = (raw) => {
            if (typeof raw !== "string" || !/^[A-Za-z0-9][A-Za-z0-9_-]{0,254}$/.test(raw))
                throw new Error();
            return raw;
        };
        const endpoint = (raw, protocol) => {
            if (typeof raw !== "string" || raw.length > 2048 || /[\s\u0000-\u001f\u007f\\]/.test(raw))
                throw new Error();
            const url = new URL(raw);
            if (!raw.toLowerCase().startsWith(`${protocol}//`) || url.protocol !== protocol ||
                !hasPublicEndpointHost(url) || (url.port && url.port !== "443") ||
                url.username || url.password || raw.includes("?") || raw.includes("#"))
                throw new Error();
            return url.href;
        };
        return {
            schemaVersion: 1, environment: value.environment,
            tenantId: identifier(value.tenantId), applicationId: identifier(value.applicationId),
            gatewayUrl: endpoint(value.gatewayUrl, "https:"), realtimeUrl: endpoint(value.realtimeUrl, "wss:"),
        };
    }
    catch {
        throw new TypeError("Invalid Mindset customer configuration.");
    }
}
//# sourceMappingURL=customer-configuration.js.map